'use client';

import * as React from 'react';

import { Dashboard } from '@/shared/i18n';
import { ContentsSection } from '../shared';
import { initialPagination } from '../../utils/pagination';
import { DashboardEventKeys, DashboardEvents } from '../../events';
import { EventBus } from '@/shared/utils';
import { useDashboardStore } from '../../store/dashboard-store';
import { routes } from 'src/shared/utils/routes';
import { getVideoCompletionPercentage } from '../../utils/return-video-completion-percentage';

interface DashboardContentsInProgressProps {
  dict: Dashboard;
  eventBus: EventBus<DashboardEvents>;
}

const DashboardContentsInProgress: React.FC<DashboardContentsInProgressProps> = ({
  dict,
  eventBus,
}) => {
  const { contentsInProgress } = useDashboardStore();

  React.useEffect(() => {
    if (!contentsInProgress?.data?.data)
      eventBus.emit(DashboardEventKeys.contentsInProgress.view, initialPagination);
  }, [contentsInProgress?.data?.data, eventBus]);

  return (
    <ContentsSection
      type="slider"
      title="Percorsi iniziati"
      isLoading={contentsInProgress.status.isLoading}
      isError={contentsInProgress.status.isError}
      fetchMore={(page, pageSize) =>
        eventBus.emit(DashboardEventKeys.contentsInProgress.view, { page, pageSize })
      }
      pagination={contentsInProgress?.data?.pagination}
      data={
        contentsInProgress?.data?.data?.map((el) => {
          const adapdedProgress = el?.lessons?.map((l) => ({
            duration: l.duration,
            progress_status: l.lessonProgresses?.[0]?.progress_status,
            current_second: l.lessonProgresses?.[0]?.current_second,
          }));
          const summedLessonsProgress = adapdedProgress?.reduce((acc, curr) => {
            if (curr?.progress_status === 'completed') return acc + (curr?.duration || 0);
            return acc + (curr?.current_second || 0);
          }, 0);

          const summedDuration = el?.lessons?.reduce((acc, curr) => acc + (curr.duration || 0), 0);
          const videoCompletionPercentage = getVideoCompletionPercentage(
            summedDuration,
            summedLessonsProgress,
          );
          return {
            documentId: el?.documentId,
            courseType: 'Percorsi',
            title: el?.title,
            isCourseStarted: true,
            isSmallCard: true,
            progressValue: videoCompletionPercentage || 0,
            imageSrc: el?.thumbnail?.url || '/assets/images/video-play.svg',
            coursePercentage: videoCompletionPercentage || 0,
          };
        }) || []
      }
      onCardClickCallback={(item) => {
        eventBus.emit(DashboardEventKeys.redirects.to, {
          url: routes.learningPathDetails.makeUrl(item.documentId, item.title),
          isExternalPage: false,
        });
      }}
      hasNavigationButtons={
        !!contentsInProgress?.data?.data?.length && contentsInProgress?.data?.data?.length > 3
      }
      hasLink={false}
      dict={dict}
      eventBus={undefined}
    />
  );
};
export default DashboardContentsInProgress;
